import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import { getLabel } from '@bibliocommons/utils-filter';
import './ActiveFilters.scss';
import { withRouter } from '@bibliocommons/utils-routing';
import { bindAll } from '@bibliocommons/utils-react';
import { routerShape } from '@bibliocommons/bc-prop-types';
import { Button } from '@bibliocommons/deprecated-base-buttons';
import { FILTER_PREFIX, FILTER_SEPARATOR } from 'app/constants/BibConstants';
import getToggledFilter from 'app/helpers/facets/getToggledFilter';
import ActiveFilterLockSwitch from '../ActiveFilterLockSwitch';
import ActiveFilterToken from '../../deprecated/shared/Facets/ActiveFilterToken';
import updateSearchQuery from '../../../helpers/search/updateSearchQuery';

export class ActiveFilters extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClearFilters() {
    const { searchType, router } = this.props;
    const query = updateSearchQuery({
      currentQuery: router.query,
      searchType,
      page: undefined
    });

    router.push({ query });
  }

  handleToggleFilter(fieldId, currentFilter) {
    const { activeFilters, router, searchType } = this.props;

    const query = updateSearchQuery({
      currentQuery: router.query,
      activeFilters,
      searchType,
      page: undefined,
      ...getToggledFilter({ fieldId, currentFilter, activeFilters, separator: FILTER_SEPARATOR, prefix: FILTER_PREFIX })
    });

    router.push({ query });
  }

  renderClearFilter() {
    if (!this.props.activeFilters.isEmpty()) {
      return (
        <Button className="cp-filter-token clear-token" handleClick={this.handleClearFilters}>
          <FormattedMessage id="clear_filters" />
        </Button>
      );
    }

    return null;
  }

  renderActiveFilters(fieldId, filter) {
    const normalizedId = fieldId === 'PRIMARY_LANGUAGE' ? 'LANGUAGE' : fieldId;
    const filterLabel = getLabel(
      this.props.intl,
      normalizedId,
      filter.get('label') || filter.get('value'),
      this.props.singleBranch
    );

    return (
      <ActiveFilterToken
        key={`${fieldId}.${filter.get('value')}`}
        handleToggleFilter={this.handleToggleFilter}
        filter={filter}
        fieldId={fieldId}
        filterLabel={filterLabel}
      />
    );
  }

  renderActiveFields() {
    return this.props.activeFilters
      .entrySeq()
      .map(([fieldId, filters]) => (filters ? filters.map(this.renderActiveFilters.bind(null, fieldId)) : null));
  }

  renderFilterControls() {
    const { activeFilters, searchType, locked, showLockSwitch } = this.props;

    return (
      showLockSwitch && (
        <div className="filter-controls">
          <FormattedMessage id="Search.activeFilters">
            {message => <span className="active-filter-label">{message}</span>}
          </FormattedMessage>
          <ActiveFilterLockSwitch searchType={searchType} active={locked} activeFilters={activeFilters} />
        </div>
      )
    );
  }

  render() {
    const activeFilterClass = cn('cp-active-filter', 'clearfix', this.props.locked ? 'active' : '');
    return (
      <div className={activeFilterClass}>
        {this.renderFilterControls()}
        <div className="filter-tokens">
          {this.renderActiveFields()}
          {this.renderClearFilter()}
        </div>
      </div>
    );
  }
}

ActiveFilters.propTypes = {
  activeFilters: ImmutablePropTypes.map,
  searchType: PropTypes.string,
  locked: PropTypes.bool,
  singleBranch: PropTypes.bool,
  showLockSwitch: PropTypes.bool,
  router: routerShape.isRequired
};

ActiveFilters.defaultProps = {
  showLockSwitch: true
};

export default injectIntl(withRouter(ActiveFilters));
